/* eslint-disable no-unused-vars */
import {
    getForms,
    saveForm,
    saveFromSchema,
    getSelectedform,
    activedeactiveForm,
    requestForReview,
    requestForApproval,
    requestForReject,
    requestForPublish,
    getPublishedForm,
    getPublishedFormCollection,
    getApplications,
    getAllForms,
    cloneForm,
    revertBackToPublishedForm,
} from '../../services/formsService';
import _ from "lodash";

const state = {
    forms: {},
    selectedform: {},
    publishedForm: {},
    publishedFormCollection: {},
    selectedFilters: {},
    applications: {},
    filters: {},
}

const getters = {
    getForms(state) {
        return state.forms;
    },
    getSelectedForm(state) {
        return state.selectedform;
    },
    getPublishedForm(state) {
        return state.publishedForm
    },
    getPublishedFormCollection(state) {
        return state.publishedFormCollection
    },
    getLiveForm(state){
        return state.liveForm
    },
    getSelectedFilters(state){
        return state.selectedFilters
    },
    getApplicationsData(state){
        return state.applications
    },
    getFilters(state){
        return state.filters
    }
}


const actions = {
    getApplications({ commit }) {
        return new Promise((resolve, reject) => {
            getApplications().then(response => {
                if(response.status==200){
                    let result=_.clone(response.data.data);
                    let  appresponse = result.map(el => ({ ...el, status:el.isActive?'Active':'InActive'}))              
                    commit('setApplicationsData', appresponse);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getPagingForms({ commit },input) {
        return new Promise((resolve, reject) => {
            getForms(input).then(response => {
                if (response.status == 200) {
                    let result= response.data.data.pageResult;
                    result.totalRecords = response.data.data.totalRecords;
                    result.pageNo = response.data.data.pageNo;
                    commit('setForms', result);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getAllForms({ commit }) {
        return new Promise((resolve, reject) => {
            getAllForms().then(response => {
                if (response.status == 200) {
                    commit('setForms', response.data.data);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    saveForm({ commit }, form) {
        return new Promise((resolve, reject) => {
            saveForm(form).then(response => {
                if (response.status == 200) {
                    // let applications = _.clone(state.applications);
                    let result = _.clone(response.data.data);
                    // if (!application.IsEditMode) {
                    //     applications.push(result);

                    commit('setForms', result);
                    // }
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    cloneForm({ commit }, form) {
        return new Promise((resolve, reject) => {
            cloneForm(form).then(response => {
                if (response?.status == 200) {
                    // let applications = _.clone(state.applications);
                    let result = _.clone(response.data.data);
                    // if (!application.IsEditMode) {
                    //     applications.push(result);
                    commit('setForms', result);
                    // }
                    resolve();
                } else {
                    console.log(response);
                    reject(new Error(`Server returned status ${response?.status}`));
                }
            }).catch(error => {
                console.error('Server-side error:', error);
                reject(error);
            });
        });
    },
    saveFromSchema({ commit }, formSchema) {
        return new Promise((resolve, reject) => {
            saveFromSchema(formSchema).then(response => {
                if (response.status == 200) {
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getSelectedform({ commit }, formid) {
        return new Promise((resolve, reject) => {
            getSelectedform(formid).then(response => {
                if (response.status == 200) {
                    commit('setSelectedForm', response.data.data);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    activedeactiveForm({ commit }, form) {
        return new Promise((resolve, reject) => {
            activedeactiveForm(form).then(response => {
                resolve();
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    requestForReview({ commit }, form) {
        return new Promise((resolve, reject) => {
            requestForReview(form).then(response => {
                resolve();
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    requestForApproval({ commit }, form) {
        return new Promise((resolve, reject) => {
            requestForApproval(form).then(response => {
                resolve();
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    requestForReject({ commit }, form) {
        return new Promise((resolve, reject) => {
            requestForReject(form).then(response => {
                resolve();
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    requestForPublish({ commit }, form) {
        return new Promise((resolve, reject) => {
            requestForPublish(form).then(response => {
                resolve();
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getPublishedForm({ commit }, form) {
        return new Promise((resolve, reject) => {
            getPublishedForm(form).then(response => {
                if (response.status == 200) {
                    commit('setPublishedForm', response.data.data);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        })
    },
    getPublishedFormCollection({ commit }, details) {
        return new Promise((resolve, reject) => {
            getPublishedFormCollection().then(response => {
                if (response.status == 200) {
                    commit('setPublishedFormCollection', response.data.data);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    revertBackToPublishedForm({ commit }, form) {
        return new Promise((resolve, reject) => {
            revertBackToPublishedForm(form).then(response => {
                if (response.status == 200) {
                    commit('setPublishedForm', response.data.data);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        })
    },
}

const mutations = {
    setForms(state, response) {
        state.forms = response;
    },
    setSelectedForm(state, response) {
        state.selectedform = response;
    },
    setPublishedForm(state, response) {
        state.publishedForm = response;
    },
    setPublishedFormCollection(state, response) {
        state.publishedFormCollection = response;
    },
    setLiveForm(state,response){
        state.liveForm=response;
    },
    setSelectedFilters(state,response){
        state.selectedFilters = response;
    },
    clearFilters(state,response){
        state.selectedFilters = response;
    },
    setApplicationsData(state,response){
        state.applications = response;
    },
    setFilters(state,response){
        state.filters = response;
    }
}

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
}